module.exports = __webpack_public_path__ + "static/media/results.b7913ea5.jpg";